import {DotLottieReact} from "@lottiefiles/dotlottie-react";

const LoadingAnimation: React.FC = () => {
	return (
		<div className="bg-black/30 absolute -left-[50px] -top-[50px] z-50 flex h-[calc(100%+100px)] w-[calc(100%+100px)] flex-col items-center justify-center gap-4 self-stretch backdrop-blur">
			<DotLottieReact
				className="w-[35rem]"
				src="/Online_LoadingScreenVariantGreen04_1x1_v1r3.json"
				autoplay
				loop
			></DotLottieReact>
		</div>
	);
};

export default LoadingAnimation;
